"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const api_1 = require("@/api");
const functions_1 = require("@/common/functions");
const string_utils_1 = require("@/common/string_utils");
const errors_1 = require("@/common/errors");
function default_1({ isLoggedIn = true, setPending = () => { }, roomId, onLikeChanged, noToast, isToastMessageBottom, onClickLikeListAnchorAltFunc, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const isDevelopment = process.env.NODE_ENV !== 'production';
        // ? dev 5814, 5809, 5787
        // ! prod
        const KV_INHIBITOR = isDevelopment ? [5814, 5809, 5787] : [309193, 309204, 309215];
        const isProhibited = KV_INHIBITOR.includes(roomId);
        if (isProhibited) {
            (0, functions_1.showToastMessage)({
                message: i18next_1.default.t('이 폼은 찜을 누를 수 없어요'),
            });
        }
        else {
            (0, functions_1.tempDisableClick)(500);
            if (isLoggedIn) {
                setPending(true);
                const formData = new FormData();
                formData.append('room_id', String(roomId));
                yield (0, api_1.postFormData)('/room/api/room/like', formData)
                    .then(res => {
                    if (res.data.status === 501) {
                        window.location.replace((0, string_utils_1.loginReturnPath)());
                    }
                    else if (res.data.status === 200) {
                        const liked = res.data.is_like;
                        onLikeChanged(liked);
                        if (liked && !noToast) {
                            (0, functions_1.showToastMessage)({
                                message: i18next_1.default.t('찜목록에 추가되었어요'),
                                isBottom: isToastMessageBottom,
                                toastAnchor: {
                                    href: '/room/feed-new/?feed=heart',
                                    text: i18next_1.default.t('찜목록보기'),
                                },
                                onClickAnchorAltFunc: onClickLikeListAnchorAltFunc,
                            });
                        }
                    }
                })
                    .catch(err => { var _a, _b, _c; return alert(((_c = (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.result) === null || _c === void 0 ? void 0 : _c.detail) || (0, errors_1.commonErrorMsg)()); })
                    .finally(() => setPending(false));
            }
            else {
                (0, functions_1.showToastMessage)({
                    message: i18next_1.default.t('찜은 로그인 후 이용할 수 있어요!'),
                    isBottom: isToastMessageBottom,
                });
            }
        }
    });
}
exports.default = default_1;
